var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialDispatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.411-160.667q-49.411 0-84.078-34.611t-34.667-84.055H40v-454.001q0-27 19.833-46.833T106.666-800h572.667v164.667h110l130.667 174v182h-74q0 49.444-34.588 84.055-34.588 34.611-84 34.611t-84.078-34.611q-34.667-34.611-34.667-84.055H348q0 49.333-34.589 84-34.588 34.666-84 34.666Zm-.078-66.666q21.667 0 36.834-15.167 15.166-15.167 15.166-36.833 0-21.667-15.166-36.834-15.167-15.167-36.834-15.167t-36.834 15.167Q177.333-301 177.333-279.333q0 21.666 15.166 36.833 15.167 15.167 36.834 15.167ZM106.666-346h25.333q17-24 41.694-38.333 24.694-14.334 55.001-14.334Q259-398.667 284-384q25 14.667 42 38h286.667v-387.334H106.666V-346Zm620.668 118.667q21.666 0 36.833-15.167 15.167-15.167 15.167-36.833 0-21.667-15.167-36.834-15.167-15.167-36.833-15.167-21.667 0-36.834 15.167-15.167 15.167-15.167 36.834 0 21.666 15.167 36.833 15.167 15.167 36.834 15.167ZM679.333-430H860L756-568.667h-76.667V-430ZM360-532.666Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialDispatch);
export default __webpack_public_path__ + "static/media/Material Dispatch.b428e286dd6d0d43886e6ac60a9f908a.svg";
export { ForwardRef as ReactComponent };